import { faker } from '@faker-js/faker';
import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { replacePathParams } from '@utils/replacePathWithParams';

const getUpload = (uploadId: string) => ({
  id: uploadId,
  siteUserId: faker.string.uuid(),
  uploadDate: faker.date.past(),
  patientId: faker.string.uuid(),
  visitId: faker.string.uuid(),
  siteId: faker.string.uuid(),
  fileType: faker.string.fromCharacters(['DXA', 'DICOM']),
  verifications: [
    {
      id: faker.string.uuid(),
      status: faker.string.fromCharacters(['WARNING', 'RESOLVED', 'SUCCESS']),
      type: faker.word.noun(),
      title: faker.word.noun(),
      message: faker.word.noun(),
      comment: faker.lorem.sentence(),
      index: faker.number.int(),
    },
  ],
  status: faker.string.fromCharacters([
    'CREATED',
    'UPLOADED',
    'FAILED',
    'NOT_VALID',
    'DELETED',
    'VALIDATED',
    'ANONYMIZED',
    'DICOM_UPLOADED',
    'COMPLETE',
  ]),
  preProcessingStatus: faker.string.fromCharacters([
    'CREATED',
    'UPLOADED',
    'NOT_VALID',
    'VALIDATED',
    'PARSING_FAILED',
  ]),
  workflows: [
    {
      started: faker.date.past(),
      finished: faker.date.past(),
      type: faker.string.fromCharacters(['PARSER', 'ANONYMIZER']),
      status: faker.string.fromCharacters([
        'IN_PROGRESS',
        'COMPLETED',
        'FAILED',
      ]),
      executionId: faker.string.uuid(),
    },
  ],
  comment: faker.lorem.sentence(),
  questionnaireResponse: {
    questionnaireId: faker.string.uuid(),
    response: {
      'date of birth': faker.date.past(),
      'acquisition date': faker.date.recent(),
      'technologist name': faker.person.fullName(),
    },
  },
});

export const fetchQCTaskUploadMock = async (
  taskId: string,
  uploadId: string
) => {
  const data = getUpload(uploadId);
  axiosMock
    .onGet(replacePathParams(API_URL.qcTaskUpload, { taskId, uploadId }))
    .reply(200, data);
  axiosMock.onGet(
    replacePathParams(API_URL.qcTaskUpload, { taskId, uploadId })
  );
};
